// add your site specific javascript here
(function ( $ ) {
	'use strict';

	$.ajaxSetup( {
		cache: true
	} );

	//For crawler
	if ( !window.JS_ENABLED ) {
		$.ajax( {
			url:      window.makeUrl( { module: 'eshop', action: 'setJavascriptEnabled' } ),
			type:     'post',
			dataType: 'json'
		} );
	}
	
	$.urlParam = function(name){
		var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
		if (results==null) {
		return null;
		}
		return decodeURI(results[1]) || 0;
	}

	// -----------------------------------------------------------------------------------------------------------------
	// Anything to be initialized on document ready goes here

	$( function () {
		//First modal registration
		$( '#registrationModalThanks' ).modal( 'show' );

		// If we have an "active" tab we start with that one selected, otherwise we select the first one
		$( '.nav-tabs' ).each( function () {
			var $activeTab = $( this ).find( '.active [data-toggle="tab"]:first' );

			if ( $activeTab.length ) {
				$activeTab.tab();
			} else {
				$( this ).find( '[data-toggle="tab"]:first' ).tab();
			}
		} );

		// Tooltips
		//$('[data-toggle="tooltip"]').tooltip();

		// Carousel Settings - Home
		$( '.carousel' ).carousel( {} );

        // SWIPE CAROUSEL
        var $carousel = $( '.carousel' );
        if ( $carousel.length ) {
            $carousel.swiperight( function () {
                $( this ).carousel( 'prev' );
            } );
            $carousel.swipeleft( function () {
                $( this ).carousel( 'next' );
            } );
        }
	} );

	$( function () {
		$( this ).find( '[data-zg-role="search-input"]').each( function(){
				//Bind the search function
				$( this ).on('input paste', function(){


					// Retrieve the input field text and reset the count to zero
					var filter = $(this).val(), count = 0;

					// Loop through the comment list
					$('[data-zg-role="search-items"]').each(function(){

						// If the list item does not contain the text phrase fade it out
						if ($(this).text().search(new RegExp(filter, "i")) < 0) {
							$(this).fadeOut();

							// Show the list item if the phrase matches and increase the count by 1
						} else {
							$(this).show();
							//if is the first visible I also show the function definition
							/*if(count == 0){
								console.log($(this).find('a'));
							}*/

							count++;
						}
					});

					// Update the count
					if(count > 0){
						$("#noResult").addClass('hide');
					}
					else{
						$("#noResult").removeClass('hide');
					}
					$("#filter-count").text(count);
					$(".count-hide").removeClass('hide');

				});
			}
		);

	});

	//Scroll slowly to the target
	$( function () {
		$('[data-zg-scrollTo="slowly"]').click(function () {
			var target = $(this).data('zg-target'),
				href = $(this).attr("href");
			$('html, body').animate({scrollTop: $(target).offset().top - 100}, 1000);
			window.location.hash = href;
		});
	});

	/*
		$(document).on('change', '#registershipping_address_addr_1', function() {
			console.log('change');
			var Key = "YF77-FA99-ZW81-GX97";
			var Text ="";

			Capture_Interactive_Find_v1_00(Key, Text, Container, Origin, Countries, Limit, Language);
		});



		function Capture_Interactive_Find_v1_00(Key, Text, Container, Origin, Countries, Limit, Language) {
			$.getJSON("http://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.00/json3.ws?callback=?",
				{
					Key: Key,
					Text: Text,
					Container: Container,
					Origin: Origin,
					Countries: Countries,
					Limit: Limit,
					Language: Language
				},
				function (data) {
					// Test for an error
					if (data.Items.length == 1 && typeof(data.Items[0].Error) != "undefined") {
						// Show the error message
						alert(data.Items[0].Description);
					}
					else {
						// Check if there were any items found
						if (data.Items.length == 0)
							alert("Sorry, there were no results");
						else {
							// PUT YOUR CODE HERE
							// FYI: The output is a JS object (e.g. data.Items[0].Id), the keys being:
							// Id
							// Type
							// Text
							// Highlight
							// Description
						}
					}
				});
		}
	*/


	// INIT OWL CAROUSEL

	$("#owl-carousel-stores").owlCarousel({
		items: 2,
		mouseDrag: true,
    	touchDrag: false,
		lazyLoad: true,
		nav: true,
		margin: 30,
		navText: [
			"<i class='icon-arrow-prev'></i>",
			"<i class='icon-arrow-next'></i>"],
		autoPlay: false,
		dots: false,
		responsive: {
			0:{
				items: 1,
				mouseDrag: false,
        		touchDrag: true,
				nav: false,
				dots: true
			},
			768:{
				items: 2,
				mouseDrag: false,
        		touchDrag: true
			},
			1000:{
		    	items: 2
			}
	  	}
	});
	
	$("#owl-carousel-banner").owlCarousel({
		items: 1,
		nav: false,
		autoPlay: false,
		lazyLoad: true,
		video: true,
		dots: false,
		nav: true,
		navText: [
			"<i class='icon-arrow-prev'></i>",
			"<i class='icon-arrow-next'></i>"]
	});

	$("#owl-carousel-highlight-secondary").owlCarousel({
		items: 3,
		mouseDrag: true,
    	touchDrag: false,
		lazyLoad: true,
		nav: true,
		navText: [
			"<i class='icon-arrow-prev'></i>",
			"<i class='icon-arrow-next'></i>"],
		autoPlay: false,
		margin: 2,
		dots: false,
		responsive: {
			0:{
				items: 1,
				mouseDrag: false,
        		touchDrag: true,
				stagePadding: 30
			},
			768:{
				items: 3,
				stagePadding: 0,
				mouseDrag: false,
        		touchDrag: true
			},
			1000:{
		    	items: 3,
				stagePadding: 0
			}
	  	}
	});
	
	$(".owl-carousel-product-page").owlCarousel({
		items: 4,
		mouseDrag: true,
    	touchDrag: false,
		lazyLoad: true,
		nav: true,
		margin: 10,
		autoPlay: false,
		dots: false,
		responsive: {
			0:{
				items: 2,
				mouseDrag: false,
        		touchDrag: true
			},
			768:{
				items: 3,
				mouseDrag: false,
        		touchDrag: true,
				stagePadding: 0,
				navText: [
				"<i class='icon-arrow-prev'></i>",
				"<i class='icon-arrow-next'></i>"]
			},
			1000:{
		    items: 4,
				stagePadding: 0,
				navText: [
				"<i class='icon-arrow-prev'></i>",
				"<i class='icon-arrow-next'></i>"]
			}
	  	}
	});
	
	$("#owl-carousel-personal-shopper").owlCarousel({
		items: 4,
		mouseDrag: true,
   		touchDrag: false,
		lazyLoad: true,
		nav: true,
		autoPlay: false,
		dots: false,
		margin: 10,
		responsive: {
			0:{
				items: 1,
				mouseDrag: false,
        		touchDrag: true,
				stagePadding: 40
			},
			768:{
				items: 3,
				mouseDrag: false,
        		touchDrag: true,
				stagePadding: 0,
				navText: [
				"<i class='icon-arrow-prev'></i>",
				"<i class='icon-arrow-next'></i>"]
			},
			1000:{
		   	items: 4,
				stagePadding: 0,
				navText: [
				"<i class='icon-arrow-prev'></i>",
				"<i class='icon-arrow-next'></i>"]
			}
	  	}
	});
	
	$("#owl-carousel-new-arrivals").owlCarousel({
		items: 4,
		mouseDrag: true,
    	touchDrag: false,
		lazyLoad: true,
		nav: true,
		autoPlay: false,
		dots: false,
		margin: 10,
		responsive: {
			0:{
				items: 1,
				mouseDrag: false,
        		touchDrag: true,
				stagePadding: 40
			},
			768:{
				items: 3,
				mouseDrag: false,
        		touchDrag: true,
				stagePadding: 0,
				navText: [
			"<i class='icon-arrow-prev'></i>",
			"<i class='icon-arrow-next'></i>"]
			},
			1000:{
		   	items: 4,
				stagePadding: 0,
				navText: [
			"<i class='icon-arrow-prev'></i>",
			"<i class='icon-arrow-next'></i>"]
			}
	  	}
	});
	
	
	$("#owl-carousel-wishlist").owlCarousel({
		items: 4,
		mouseDrag: true,
    	touchDrag: false,
		nav: true,
		autoPlay: false,
		dots: false,
		margin: 10,
		responsive: {
			0:{
				items: 1,
				mouseDrag: false,
        		touchDrag: true
			},
			768:{
				items: 3,
				mouseDrag: false,
        		touchDrag: true,
				navText: [
					"<i class='icon-arrow-prev'></i>",
					"<i class='icon-arrow-next'></i>"]
			},
			1000:{
		   	items: 4,
				stagePadding: 0,
				navText: [
					"<i class='icon-arrow-prev'></i>",
					"<i class='icon-arrow-next'></i>"]
			}
	  	}
	});
	
	$("#owl-carousel-flashsales").owlCarousel({
		items: 2,
		mouseDrag: true,
    	touchDrag: false,
		lazyLoad: true,
		nav: true,
		navText: [
					"<i class='icon-arrow-prev'></i>",
					"<i class='icon-arrow-next'></i>"],
		autoPlay: false,
		dots: false,
		margin: 30,
		responsive: {
			0:{
				items: 1,
				mouseDrag: false,
        		touchDrag: true,
				dots: true,
				nav: false
			},
			768:{
				items: 2,
				mouseDrag: false,
        		touchDrag: true,
				dots: true,
				nav: false
			},
			1000:{
		   	items: 2,
				dots: true,
				nav: false
			}
	  }
	});


	// OPEN/CLOSE MOBILE MENU	
	$('#responsive-menu-open').click( function() {
		$('body').addClass('menu-responsive-open');
	});
	
	$('#responsive-menu-close, .js-close-menu').click( function() {
		$('body').removeClass('menu-responsive-open');
	});
	
	// OPEN/CLOSE MOBILE FILTERS	
	$('#filter-trigger, .js-close-filter-menu').click( function() {
		$('body').toggleClass('filter-active');
	});

	// SCROLL TOP ON CLOSE MOBILE FILTERS MENU
	$('.js-close-filter-menu').click( function() {
		$('html, body').scrollTop('400');
	});
	
	// OPEN/CLOSE SOCIAL SHARE
	$('#social-trigger').click( function() {
		$('#social-share').toggleClass('social-active');
	});
	
	
	if ( !IS_MOBILE ) {
		/* STICKY CART SUMMARY */
		var $sticky = $('#sticky-summary');
		var $stickyrStopper = $('#site_footer');
		if (!!$sticky.offset()) { // make sure ".sticky" element exists

			var generalSidebarHeight = $sticky.innerHeight();
			var stickyTop = $sticky.offset().top;
			var stickOffset = 0;
			var stickyWidth = $('.sticky-summary-wrapper').width();
			var stickyStopperPosition = $stickyrStopper.offset().top;
			var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;
			var diff = stopPoint + stickOffset;

			$(window).scroll(function(){ // scroll event
				var windowTop = $(window).scrollTop(); // returns number

				if (stopPoint < windowTop) {
					$sticky.css({ position: 'absolute', width: stickyWidth, top: diff });
				} else if (stickyTop < windowTop+stickOffset) {
						$sticky.css({ position: 'fixed', width: stickyWidth, top: stickOffset });
				} else {
						$sticky.css({position: 'absolute', width: stickyWidth, top: 'initial'});
				}
			});

		}
	}

	/* SET COOKIE UOMO - DONNA */
	function setGenderCookie(cname,cvalue,exdays) {
		//var d = new Date();
		//d.setTime(d.getTime() + (exdays*24*60*60*1000));
		//var expires = "expires=" + d.toGMTString();
		document.cookie = cname + "=" + cvalue + ";0;path=/";
	}

	function getGenderCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
						c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
						return c.substring(name.length, c.length);
				}
		}
		return "";
	}

	
	$( "#linkCookieMan, #linkCookieManMobile, #linkHUBCookieMan, #linkHUBCookieManImage" ).click(function() {
		setGenderCookie("redirectHome", "M", 0);
		//alert('sectionConfig: M');
	});
	$( "#linkCookieWoman, #linkCookieWomanMobile, #linkHUBCookieWoman, #linkHUBCookieWomanImage" ).click(function() {
		setGenderCookie("redirectHome", "F", 0);
		//alert('sectionConfig: F');
	});
	
	
	$( "#show-registration-form" ).click(function() {
		$( this ).slideUp(" slow ");
		$( "#social-login" ).slideUp(" slow ");
		$( "#panel-registration" ).slideDown(" slow ");
	});
		
	
	if ( IS_DESKTOP ) {

			/* MEGA MENU */
			for( var mmi = 0; mmi < megaMenuName.length; mmi++ ) {

				//console.log('#mega-menu__' + megaMenuName[mmi]);

				$('#mega-menu__' + megaMenuName[mmi]).mouseover( function() {

					var MMID = '#' + $(this).attr("id");
					// console.log(megaMenuName[mmi]);
					// console.log(MMID + '-object');
					//$('body').addClass('mega-menu-open');
					$('#mega-menu').slideDown('slow');
					$('.mega-menu__inner').fadeOut(50);
					$(MMID + '-object').fadeIn(50);

				});

			}

			$('#site_header').mouseleave(function() {
				$('.mega-menu').slideUp( "slow" );
			});

			$('.has-not-mega-menu').mouseover(function() {
				$('.mega-menu').slideUp( "slow" );
			});

	}

	if ( IS_MOBILE ) {
	
		/* CATEGORY MENU SLIDE IN (CMS content: mega-menu) */
		for( var mmi = 0; mmi < megaMenuName.length; mmi++ ) {

			$('#mega-menu-mobile__' + megaMenuName[mmi]).click( function() {
				var MMID = '#' + $(this).attr("id");
				var MMlink = $(this).attr("data-href");
				var MMtext = $(this).text();

				// console.log(megaMenuName[mmi]);
				// console.log(MMID);
				// console.log(MMlink);
				// console.log(MMtext);

				$('.js-mega-menu').addClass('mega-menu-open');
				$('.js-mega-menu-inner').fadeOut(50);
				$(MMID + '-object').fadeIn(50);

				$('.js-megamenu-maincat').attr('href', MMlink).text(MMtext);
				$('.js-megamenu-seeall').attr('href', MMlink);

			});

		}

	}
	
	function closeMegaMenuMobile() {
		$('.js-mega-menu').removeClass('mega-menu-open');
	}
	$('.js-close-mega-menu').click( function() {
		closeMegaMenuMobile();
	});

	
	if (catPage == true) {
		
		var navbar = $("#filter-ext-wrapper");
		var offset = navbar.offset();
		
		$(window).scroll(function() {
			if( $(this).scrollTop() >= offset.top ) {
				navbar.addClass('is-sticky');
			} else {
				navbar.removeClass('is-sticky');
			}
		});
	}		

	// FLUID SCROLL-DOWN 
	$('.fluid-scroll-down').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-50
				}, 1000);
				return false;
			}
		}
	});
	
	// SCROLL TOP BUTTON	
    $(window).scroll(function() {
        if($(this).scrollTop() != 0) {
            $('#back-to-top').fadeIn();    
        } else {
            $('#back-to-top').fadeOut();
        }
    });
 
    $('#back-to-top').click(function() {
        $('body,html').animate({ scrollTop:0 },800);
    });
	
		
	// Read more/read less button in category page on mobile
	if ( IS_MOBILE ) {
		
		$(function(){
			var showHideContent = $('#js_showHideContent'),
					showHideBtn = $('#js_showHideBtn');
			showHideBtn.click(function(){
				showHideContent.toggleClass('is-open');
			});
		})

	}

	// SHOW GRITTER ALERT IF NOT LOGGED USER ADD PRODUCT TO WISHLIST
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const addProductToWishlist = urlParams.get('addProductToWishlist')
	if(addProductToWishlist == 1) {
		$.gritter.add( {
			title:      window.JS_TRANSLATIONS['notifier.error'] || 'Error',
			text:       window.JS_TRANSLATIONS.autentication_required_to_add_a_product_to_the_wishlist,
			class_name: 'alert alert-danger',
			sticky:     true
		} );
		
	}

	// SHOW BACK TO CATEGORY LINK IN PRODUCT PAGE
	if ( productPage ) {
		let referrer =  document.referrer;
		if(referrer.indexOf('secondastrada.kooomo-preview.com' || 'www.secondastrada.com') > -1) {
			$('.js_btnBack').removeClass('hidden');
		};
	}

})( jQuery );


$(window).load(function() {
	$('body').addClass('window-loaded');
});


$(window).on('load', function() {
    // FANCYBOX
    $("[data-fancybox]").fancybox({
    });
});
